const mat4 = window.mat4;

export default {
  createBrushProgram: function(gl, shaders) {
    let program = gl.createProgram();

    let vertexShader = gl.createShader(gl.VERTEX_SHADER);
    let fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(vertexShader, shaders.vertex);
    gl.shaderSource(fragmentShader, shaders.fragment);
    gl.compileShader(vertexShader);
    gl.compileShader(fragmentShader);
    gl.enable(gl.BLEND);
    gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
    gl.blendFuncSeparate(
      gl.SRC_ALPHA,
      gl.ONE_MINUS_SRC_ALPHA,
      gl.ONE,
      gl.ONE_MINUS_SRC_ALPHA
    );

    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    gl.useProgram(program);

    // VERTEX POSITION
    var positionAttribLocation = gl.getAttribLocation(program, "vertPosition");
    gl.vertexAttribPointer(
      positionAttribLocation, // Attribute location
      2, // Number of elements per attribute
      gl.FLOAT, // Type of elements
      gl.FALSE,
      4 * Float32Array.BYTES_PER_ELEMENT, // Size of an individual vertex
      0 // Offset from the beginning of a single vertex to this attribute
    );
    gl.enableVertexAttribArray(positionAttribLocation);

    // VERTEX UV
    var uvAttribLocation = gl.getAttribLocation(program, "vertUV");
    gl.vertexAttribPointer(
      uvAttribLocation, // Attribute location
      2, // Number of elements per attribute
      gl.FLOAT, // Type of elements
      gl.FALSE,
      4 * Float32Array.BYTES_PER_ELEMENT, // Size of an individual vertex
      2 * Float32Array.BYTES_PER_ELEMENT // Offset from the beginning of a single vertex to this attribute
    );
    gl.enableVertexAttribArray(uvAttribLocation);
    return program;
  },
  createUnitQuad: function(gl) {
    let squareVerts = [].concat.apply(
      [],
      [
        [-0.5, -0.5, 0, 0], // XY, UV
        [-0.5, +0.5, 0, 1],
        [+0.5, -0.5, 1, 0],
        [+0.5, +0.5, 1, 1]
      ]
    );
    let squareIndices = [0, 1, 2, 2, 1, 3];

    var squareVertexBufferObject = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, squareVertexBufferObject);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(squareVerts),
      gl.STATIC_DRAW
    );
    var squareIndexBufferObject = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, squareIndexBufferObject);
    gl.bufferData(
      gl.ELEMENT_ARRAY_BUFFER,
      new Uint16Array(squareIndices),
      gl.STATIC_DRAW
    );
  },
  updateCanvas: function(gl, x, y, brush, color) {
    let program = gl.getParameter(gl.CURRENT_PROGRAM);

    // pixel position
    var mousePositionLocation = gl.getUniformLocation(program, "pos");
    gl.uniform2f(
      mousePositionLocation,
      x / (gl.drawingBufferWidth.width / 2) - 1,
      -y / (gl.drawingBufferWidth.height / 2) + 1
    );

    // scale test
    var matrixLocation = gl.getUniformLocation(program, "transformMatrix");

    // this matirx will convert from pixels to clip space
    var matrix = mat4.create();
    mat4.ortho(matrix, 0, gl.canvas.width, gl.canvas.height, 0, -1, 1);

    // this matrix will translate our quad to dstX, dstY
    mat4.translate(matrix, matrix, [x, y, 0]);

    // this matrix will rotate our quad
    mat4.rotateZ(matrix, matrix, -brush.angle * Math.PI / 180);

    // this matrix will scale our 1 unit quad
    // from 1 unit to texWidth, texHeight units
    mat4.scale(matrix, matrix, [
      brush.size,
      brush.size * (brush.roundness / 100),
      1
    ]);

    // Set the matrix.
    gl.uniformMatrix4fv(matrixLocation, false, matrix);

    // brush color
    var brushColorLocation = gl.getUniformLocation(program, "color");
    gl.uniform3f(
      brushColorLocation,
      color[0] / 256,
      color[1] / 256,
      color[2] / 256
    );

    // brush hardness
    var brushHardness = gl.getUniformLocation(program, "hardness");
    gl.uniform1f(brushHardness, brush.hardness);

    // brush flow
    var brushFlow = gl.getUniformLocation(program, "flow");
    gl.uniform1f(brushFlow, brush.flow);

    // brush size
    var brushSize = gl.getUniformLocation(program, "brushSize");
    gl.uniform1f(brushSize, brush.size * (brush.roundness / 100));

    // canvas size
    var canvasSize = gl.getUniformLocation(program, "canvasSize");
    gl.uniform1f(canvasSize, gl.canvas.width);

    // Draw
    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
  }
};
